import {combineReducers} from 'redux';
import {resourceReducer} from 'redux-resource';
import switchResourcePlugin from '../redux-resource-plugins/switch/index';
import authReducer from './auth';
import pageReducer from './page';

const reducers = combineReducers({
	auth: authReducer,
	page: pageReducer,
	collections: resourceReducer('collections'),
	files: resourceReducer('files'),
	uploads: resourceReducer('uploads'),
	users: resourceReducer('users'),
	languages: resourceReducer('languages', {
		initialState: {switchValue: 'en'},
		plugins: [switchResourcePlugin]
	})
});

export default reducers;



// WEBPACK FOOTER //
// ./src/client/redux/reducers/index.js